import React from "react";

export default function SendInvoiceIcon({ orderId }) {
    if (!orderId) return null;

    const handleClick = () => {
        const editUrl = `https://curbstand.com/wp-admin/post.php?post=${orderId}&action=edit&send_invoice_email=1`;
        window.open(editUrl, "_blank");
    };

    return (
        <i
            className="bx bx-file text-primary"
            title="Send Invoice"
            style={{
                cursor: "pointer",
                fontSize: 15,
                color: "#f0b429",
                marginLeft: 10,
            }}
            onClick={handleClick}
        ></i>
    );
}